<template>
    <div>
        <el-form :inline="true" :model="form" >
            <el-form-item>
                <el-input v-model="form.keyword" placeholder="请输入关键字" @change="request"></el-input>
            </el-form-item>
            <el-button type="primary" @click="loadData">搜索</el-button>
        </el-form>
        <el-card>
            <el-table :data="tableData" v-loading='loading' border @selection-change='selectclick'>
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-for='item of pageSizes' :key='item' v-if="form.pageSize===item">
                            {{form.pageIndex>1 ? scope.$index+1+(form.pageIndex-1)*item : scope.$index+1}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="用户名" prop="internalUserid"></el-table-column>
                <el-table-column label="真实姓名" prop="name"></el-table-column>
                <el-table-column label="所在部门" prop="department.name"></el-table-column>
            </el-table>

            <!-- 分页器 -->
            <el-pagination
             @size-change="handleSizeChange"
             @current-change="handleCurrentChange"
             :current-page="form.pageIndex"
             :page-sizes="[10,20, 30, 40]"
             :page-size="form.pageSize"
             layout="total, sizes, prev, pager, next, jumper"
             :total="total">
            </el-pagination>
        </el-card>
    </div>
</template>

<script>
import services from './adduser.services'
export default {
    props: {
        id: Number,
        type: String
    },
    data() {
        return {
            tableData: [],
            total: 0,
            form: {
                keyword: '',
                pageIndex: 1,
                pageSize: 10,
                enable:true
            },
            loading: true,
            pageSizes: [10, 20, 30, 40],
        }
    },
    mounted() {
        this.request()
    },
    methods: {
        loadData(){
            this.form.pageIndex=1
            this.request()
        },
        request(val) {
            services.userList(this.form)
                .then(res => {
                    this.tableData = res.list
                    this.total = res.total
                })
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },
        handleSizeChange(val){
            let pages = Math.ceil(this.total / val);
            this.form.pageSize = val;
            if(this.form.pageIndex > pages ){
                this.form.pageIndex  = 1;
            };
            this.request();
        },
        handleCurrentChange(val){
            this.form.pageIndex = val;
            this.request();
        },
        selectclick(selection){
            this.$emit('getServes', selection)
        },


    }
}
</script>

<style>
    .footer {
        margin: 20px 0;
    }
</style>
